import { Image, Container } from 'react-bootstrap'
import useWindowSize from '../../../utilities/useWindowSize'
import logo_encume from '../../../assets/img/logos/logo-blanco-global.png'
import img_encume_md from '../../../assets/img/general/encume-md.png'
import img_encume_sm from '../../../assets/img/encume-sm.png'
import './menstrual-culture-hero.css'

const MenstrualCultureHero = () => {
    const { width } = useWindowSize()

    return (
        <section className='menstrual-culture-hero'>
            <div className='menstrual-culture-hero__image-container'>
                {width > 767 ? (
                    <Image src={img_encume_md} alt='EnCuMe 2019' className='menstrual-culture-hero__image' />
                ) : (
                    <Image src={img_encume_sm} alt='EnCuMe 2019' className='menstrual-culture-hero__image' />
                )}
                <div className='menstrual-culture-hero__overlay'></div>
            </div>
            
            <div className='menstrual-culture-hero__content'>
                <div className='menstrual-culture-hero__logo-wrapper'>
                    <Image 
                        src={logo_encume}
                        alt='Logo La Vida en Rojo'
                        className='menstrual-culture-hero__logo'
                    />
                </div>
                
                <Container className='menstrual-culture-hero__text-container'>
                    <div className='menstrual-culture-hero__text-box'>
                        <h2 className='menstrual-culture-hero__title'>Nacimiento de la Asociación y su origen con el primer Encuentro de Cultura Menstrual (EnCuMe) 2019</h2>
                        <p className='menstrual-culture-hero__paragraph'>
                            La cultura menstrual que hoy nombramos y construimos colectivamente tiene una historia. En 2019, el 1er Encuentro de Cultura Menstrual (EnCuMe), celebrado en Barcelona, reunió a mujeres que, desde distintos lugares y saberes, ya estaban trabajando en torno a la menstruación. Aquel encuentro nos permitió (re)conocernos y hacer visible un micelio, una red de mujeres, experiencias, saberes y prácticas que ya estaba creciendo y conectándose. De aquel encuentro nació el deseo y la necesidad de seguir encontrándonos y organizándonos, dando lugar a la Asociación de Cultura Menstrual La Vida en Rojo.
                        </p>
                        <p className='menstrual-culture-hero__paragraph'>
                            Conocer cómo se pensó y creó aquel primer encuentro permite acercarnos a las raíces de la Asociación y a las mujeres que hicieron posible su nacimiento.
                        </p>
                        <a 
                            href='https://drive.google.com/file/d/1EBzUJp0TdqHnAqpYA2RifsthJXAq4w3h/view'
                            target='_blank'
                            rel='noopener noreferrer'
                            className='menstrual-culture-hero__button'>
                            Explora la memoria del EnCuMe
                        </a>
                    </div>
                </Container>
            </div>
        </section>
    )
}

export default MenstrualCultureHero
